import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const HelpCenterIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 0C4.92031 0 0 4.91975 0 11C0 17.0796 4.91975 22 11 22C17.0797 22 22 17.0802 22 11C22 4.92031 17.0802 0 11 0ZM11 20.4651C5.78093 20.4651 1.53489 16.2191 1.53489 11C1.53489 5.78089 5.78093 1.53489 11 1.53489C16.2191 1.53489 20.4651 5.78089 20.4651 11C20.4651 16.2191 16.2191 20.4651 11 20.4651Z"
        fill="currentColor"
      />
      <path
        d="M10.6745 13.9186C10.0664 13.9186 9.5741 14.4254 9.5741 15.0335C9.5741 15.6272 10.0519 16.1484 10.6745 16.1484C11.2971 16.1484 11.7894 15.6272 11.7894 15.0335C11.7894 14.4254 11.2826 13.9186 10.6745 13.9186Z"
        fill="currentColor"
      />
      <path
        d="M10.8627 5.47719C8.90796 5.47719 8.01025 6.63558 8.01025 7.41744C8.01025 7.98214 8.48807 8.24279 8.879 8.24279C9.6609 8.24279 9.34237 7.12783 10.8193 7.12783C11.5432 7.12783 12.1224 7.4464 12.1224 8.11246C12.1224 8.89432 11.3115 9.34317 10.8337 9.74858C10.4138 10.1105 9.86362 10.7042 9.86362 11.9494C9.86362 12.7023 10.0664 12.9195 10.66 12.9195C11.3694 12.9195 11.5142 12.601 11.5142 12.3258C11.5142 11.5729 11.5287 11.1386 12.3251 10.516C12.716 10.2119 13.9467 9.22729 13.9467 7.86625C13.9467 6.50522 12.716 5.47719 10.8627 5.47719Z"
        fill="currentColor"
      />
    </svg>
  )
})

HelpCenterIcon.displayName = 'HelpCenterIcon'
